import React, { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import LP1 from "./components/LP/lp1";
import ContactFormModal from "./components/ContactForm";
import RLPVIAgents from "./components/RLPVIAgents";
import Support from "./components/Support";
import About from "./components/About";

// Lazy-load legal pages for performance
const Privacy = lazy(() => import("./components/legal/Privacy"));
const Terms = lazy(() => import("./components/legal/Terms"));
const Delete = lazy(() => import("./components/legal/Delete"));

// Simple analytics tracker
const trackPageView = (pathname) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: pathname });
  }
};

function App() {
  const [openModal, setOpenModal] = useState(false);
  const location = useLocation();

  console.log(">>> LIVE App.js @", new Date().toISOString());

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <LP1 handleOpenModal={() => setOpenModal(true)} />
                <ContactFormModal
                  open={openModal}
                  handleClose={() => setOpenModal(false)}
                />
              </>
            }
          />

          {/* Core pages */}
          <Route path="/support" element={<Support />} />
          <Route path="/about" element={<About />} />
          <Route path="/RLPVIAgents" element={<RLPVIAgents />} />

          {/* Legal pages */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/delete-account" element={<Delete />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
